module.exports = __webpack_public_path__ + "9f2144213fad53d4e0fdb26ecf93865f.woff";


//////////////////
// WEBPACK FOOTER
// ./node_modules/open-sans-fontface/fonts/Semibold/OpenSans-Semibold.woff?v=1.1.0
// module id = 994
// module chunks = 0